import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=6a8c1125"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8c1125')) {
      api.createRecord('6a8c1125', component.options)
    } else {
      api.reload('6a8c1125', component.options)
    }
    module.hot.accept("./personal.vue?vue&type=template&id=6a8c1125", function () {
      api.rerender('6a8c1125', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/personal.vue"
export default component.exports